import { render, staticRenderFns } from "./Pobill.vue?vue&type=template&id=2f65e01e&"
import script from "./Pobill.vue?vue&type=script&lang=js&"
export * from "./Pobill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports